var React = require('react');

function ArrowAccordion (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M10.4697 0.367188L11.5304 1.42785L6.00006 6.95818L0.469727 1.42785L1.53039 0.367188L6.00006 4.83686L10.4697 0.367188Z"}));
}

ArrowAccordion.defaultProps = {"width":"12","height":"7","viewBox":"0 0 12 7","fill":"none"};

module.exports = ArrowAccordion;

ArrowAccordion.default = ArrowAccordion;
